export default [
  {
    path: window.pathApp + '/minha-carteira',
    name: 'minha.carteira',
    component: () => import('@/components/MinhaCarteira'),
    meta: {
      login: true,
      avisoCarrinho: true,
      title: "Minha Carteira",
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/routes/minha_carteira.js